import { EdgePanel } from "@pax/ui";
import { CreditsPane } from "./CreditsPane";

/** Your credits on a phone, coming up from the foot the way your account does. */
export function CreditsSheet({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  return (
    <EdgePanel
      open={open}
      onOpenChange={onOpenChange}
      title="Credits"
      className="inset-x-0 top-(--sheet-top) bottom-0 rounded-t-(--sheet-radius)"
    >
      <CreditsPane onClose={() => onOpenChange(false)} />
    </EdgePanel>
  );
}
